import { useState } from 'react';
import {
  IconMail,
  IconBrandInstagram,
  IconBrandWhatsapp,
  IconClock,
  IconSend,
} from '@tabler/icons-react';
import { useSiteContent } from '../context/SiteContentContext';
import { sendContactMessage } from '../lib/forms';
import GuyanaStripe from '../components/layout/GuyanaStripe';
import PageTitle from '../components/ui/PageTitle';
import './ContactPage.css';

export default function ContactPage() {
  var content = useSiteContent();
  var c = content.c;
  var _sent = useState(false);
  var sent = _sent[0]; var setSent = _sent[1];
  var _sending = useState(false);
  var sending = _sending[0]; var setSending = _sending[1];
  var _error = useState('');
  var error = _error[0]; var setError = _error[1];
  var _form = useState({ name: '', email: '', category: '', order_number: '', message: '' });
  var form = _form[0]; var setForm = _form[1];

  var categories = c('contact_categories', '').split(',').filter(Boolean);

  var contactCards = [
    { icon: IconMail, label: 'Email', value: c('contact_email'), note: 'Usually responds within 24 hours' },
    { icon: IconBrandInstagram, label: 'Instagram', value: c('contact_instagram'), note: 'DMs open for quick questions' },
    { icon: IconBrandWhatsapp, label: 'WhatsApp', value: c('contact_whatsapp'), note: 'Text or voice message' },
    { icon: IconClock, label: 'Workshop hours', value: c('contact_hours'), note: 'Georgetown, Guyana' },
  ];

  async function handleSubmit(e) {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    setError('');
    var res = await sendContactMessage(form);
    setSending(false);
    if (res.error) {
      setError(res.error);
      return;
    }
    setSent(true);
  }

  function handleChange(field, value) {
    setForm(Object.assign({}, form, { [field]: value }));
  }

  return (
    <>
      <PageTitle title="Contact" />
      <section className="contact-hero page-band">
        <h1 className="contact-hero__headline page-band__title">Questions about an order, a product, or a custom request?</h1>
      </section>

      <GuyanaStripe />

      <div className="container contact-layout">
        <div className="contact-cards">
          {contactCards.map(function(card, i) {
            return (
              <div className="contact-card" key={i}>
                <div className="contact-card__icon"><card.icon size={18} /></div>
                <div>
                  <div className="contact-card__label">{card.label}</div>
                  <div className="contact-card__value">{card.value}</div>
                  <div className="contact-card__note">{card.note}</div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="contact-form-wrap">
          {sent ? (
            <div className="contact-sent">
              <div className="contact-sent__icon">{'\u2713'}</div>
              <h3>Message sent</h3>
              <p>Thanks for reaching out. Andre will get back to you within 24 hours.</p>
              <button onClick={function() { setSent(false); setForm({ name:'', email:'', category:'', order_number:'', message:'' }); }}>
                Send another message
              </button>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form__row2">
                <div className="contact-form__field"><label>Name</label><input type="text" value={form.name} onChange={function(e) { handleChange('name', e.target.value); }} required /></div>
                <div className="contact-form__field"><label>Email</label><input type="email" value={form.email} onChange={function(e) { handleChange('email', e.target.value); }} required /></div>
              </div>
              <div className="contact-form__field"><label>What is this about?</label>
                <select value={form.category} onChange={function(e) { handleChange('category', e.target.value); }}>
                  <option value="">Select a category</option>
                  {categories.map(function(cat, i) { return <option key={i} value={cat}>{cat}</option>; })}
                </select>
              </div>
              <div className="contact-form__field"><label>Order number (optional)</label><input type="text" value={form.order_number} onChange={function(e) { handleChange('order_number', e.target.value); }} placeholder="e.g. AM-00142" /></div>
              <div className="contact-form__field"><label>Message</label><textarea value={form.message} onChange={function(e) { handleChange('message', e.target.value); }} rows={5} required /></div>
              {error && <p className="contact-form__error" role="alert">{error}</p>}
              <button type="submit" className="contact-form__submit" disabled={sending}><IconSend size={14} /> {sending ? 'Sending…' : 'Send message'}</button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}